"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  :root {\n    --outline-call-attention-color: ", ";\n  }\n  .call-attention-active {\n    position: relative;\n    border-radius: ", ";\n    animation: ", " 1s linear;\n    &::before {\n      display: block;\n      content: ' ';\n      position: absolute;\n      inset: 0;\n      background: ", ";\n      border-radius: ", ";\n      animation: ", " 1.25s cubic-bezier(0.16, 1, 0.3, 1);\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    outline: 0px solid transparent;\n  }\n  10% {\n    outline: 0px solid transparent;\n  }\n  20% {\n    outline: 2px solid var(--outline-call-attention-color);\n  }\n  70% {\n    outline: 2px solid var(--outline-call-attention-color);\n  }\n  80% {\n    outline: 0px solid transparent;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    inset: 0;\n    opacity: 0;\n  }\n  10% {\n    opacity: 1;\n  }\n  30% {\n    opacity: 1;\n  }\n  100% {\n    inset: -15px;\n    opacity: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CallAttentionGlobalStyle = exports.callAttention = void 0;

var polished_1 = require("polished");

var styled_components_1 = require("styled-components");

var CALL_ATTENTION = 'call-attention-active';

function callAttention(element) {
  if (element.classList.contains(CALL_ATTENTION)) {
    element.classList.remove(CALL_ATTENTION);
  }

  clearTimeout(element.callAttentionHandle);
  setTimeout(function () {
    element.classList.add(CALL_ATTENTION);
    element.callAttentionHandle = setTimeout(function () {
      element.classList.remove(CALL_ATTENTION);
    }, 1000);
  }, 10);
}

exports.callAttention = callAttention;
var CallAttentionAnimation = (0, styled_components_1.keyframes)(_templateObject());
var CallAttentionContainerAnimation = (0, styled_components_1.keyframes)(_templateObject2());
exports.CallAttentionGlobalStyle = (0, styled_components_1.createGlobalStyle)(_templateObject3(), function (props) {
  return props.theme['@primary-color'];
}, function (props) {
  return props.theme['@border-radius-base'];
}, CallAttentionContainerAnimation, function (props) {
  return (0, polished_1.transparentize)(0.85, props.theme['@primary-color']);
}, function (props) {
  return props.theme['@border-radius-large'];
}, CallAttentionAnimation);